<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-text-field
          v-validate="required.customer"
          v-model="copyOfForm.customer"
          :label="mess['dialog_request_field_customer']"
          :error-messages="errors.collect('customerRepresentative')"
          outlined
          dense
          data-vv-name="customerRepresentative"
        />
      </v-col>

      <v-col cols="6" class="pa-0">
        <v-text-field
          v-validate="required.phone"
          v-model="copyOfForm.phone"
          :label="mess['dialog_request_field_phone']"
          :error-messages="errors.collect('representativePhone')"
          outlined
          dense
          data-vv-name="representativePhone"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0 pr-3">
        <v-select
          v-validate="required.request_form"
          v-model="copyOfForm.request_form"
          :items="requestForms"
          :label="mess['dialog_request_field_request_form']"
          :error-messages="errors.collect('request_form')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="request_form"
        />
      </v-col>

      <v-col cols="6" class="pa-0">
        <v-select
          v-validate="required.service_engineer"
          v-model="copyOfForm.service_engineer"
          :items="serviceEngineer"
          :label="mess['dialog_request_field_service_engineer']"
          :error-messages="errors.collect('service_engineer')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="service_engineer"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-menu
          v-model="dateOfRequest.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfRequest.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="copyOfForm.dateOfRequest"
              :label="mess['dialog_request_field_date_of_request']"
              :error-messages="errors.collect('dateOfRequest')"
              data-vv-name="dateOfSale"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfRequest.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfRequest.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfRequest.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-menu
          v-model="dateOfSale.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfSale.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfSale"
              v-on="on"
              :label="mess['dialog_request_field_date_of_sale']"
              :error-messages="errors.collect('dateOfSale')"
              data-vv-name="dateOfSale"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfSale.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfSale.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfSale.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-menu
          v-model="dateOfIncident.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfIncident.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="copyOfForm.dateOfIncident"
              :label="mess['dialog_request_field_date_of_incident']"
              :error-messages="errors.collect('dateOfIncident')"
              data-vv-name="dateOfSale"
              prepend-icon="event"
              readonly
              outlined
              dense
              class="request-datepicker-text-field"
            />
          </template>

          <v-date-picker v-model="dateOfIncident.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfIncident.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfIncident.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-select
          v-validate="required.request_reason"
          v-model="copyOfForm.request_reason"
          :items="requestReasons"
          return-object
          item-text="title"
          outlined
          dense
          :label="mess['dialog_request_field_request_reason']"
          :error-messages="errors.collect('request_reason')"
          data-vv-name="request_reason"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-col cols="12" class="pa-0 pb-2">
          <v-textarea
            v-model="copyOfForm.incident_description"
            :label="mess['dialog_request_field_incident_description']"
            :error-messages="errors.collect('incident_description')"
            outlined
            dense
            data-vv-name="incident_description"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-combobox
          v-validate="required.article_element"
          v-model="copyOfForm.article_element"
          :items="searchedElementArticles"
          :search-input.sync="searchElementArticle"
          :label="mess['dialog_request_field_article_element']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('article_element')"
          color="primary"
          outlined
          dense
          item-text="pdm_elementid"
          data-vv-name="article_element"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedElementArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchElementArticle', 'article_element', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              <b>{{ item.pdm_elementid }}</b>
              {{ item.pdm_oemarticle }}
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-combobox
          v-model="copyOfForm.article_original"
          :items="searchedElementArticles"
          :search-input.sync="searchOriginalArticle"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          color="primary"
          outlined
          dense
          item-text="pdm_oemarticle"
          label="OEM ID"
          data-vv-name="article_original"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedElementArticles',
              'by_oem_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchOriginalArticle', 'article_original', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              {{ item.pdm_elementid }}
              <b>{{ item.pdm_oemarticle }}</b>
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.disassembling_po_n"
          :label="mess['dialog_request_field_po_n']"
          :error-messages="errors.collect('trace_number')"
          outlined
          dense
          data-vv-name="trace_number"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-select
          v-validate="required.damage_1"
          v-model="copyOfForm.damage_1"
          :items="damages"
          :label="mess['dialog_request_field_damage_3']"
          :error-messages="errors.collect('damage_1')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="damage_1"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-combobox
          v-model="copyOfForm.articles"
          :items="searchedAdditionalArticles"
          :search-input.sync="searchAdditionalArticle"
          :label="mess['dialog_request_field_articles']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          multiple
          color="primary"
          outlined
          dense
          chips
          deletable-chips
          item-text="pdm_elementid"
          item-value="id"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedAdditionalArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchAdditionalArticle', 'articles', $event)
          "
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-textarea
          v-model="copyOfForm.damage_description"
          :label="mess['dialog_request_field_customer_comments']"
          :error-messages="errors.collect('comments')"
          outlined
          dense
          data-vv-name="comments"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-select
          v-validate="required.damage_2"
          v-model="copyOfForm.damage_2"
          :items="damages"
          :label="mess['dialog_request_field_damage_4']"
          :error-messages="errors.collect('damage_2')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="damage_2"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pa-0">
        <v-textarea
          v-model="copyOfForm.customer_requirements"
          :label="mess['dialog_request_field_customer_requirements']"
          :error-messages="errors.collect('customer_requirements')"
          outlined
          dense
          data-vv-name="customer_requirements"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-combobox
          v-model="copyOfForm.equipment"
          :items="equipments"
          :label="mess['dialog_request_field_equipment']"
          :error-messages="errors.collect('equipment')"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          color="primary"
          outlined
          dense
          hide-no-data
          item-text="pdm_oemarticle"
          data-vv-name="equipment"
          @update:search-input="onUpdateEquipmentSearchInput($event)"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.serial_number"
          :label="mess['dialog_request_field_serial_number']"
          :error-messages="errors.collect('serial_number')"
          outlined
          dense
          data-vv-name="serial_number"
          @change="copyOfForm.serial_number = $event"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.efficiency"
          :label="mess['dialog_request_field_efficiency']"
          :error-messages="errors.collect('efficiency')"
          outlined
          dense
          data-vv-name="efficiency"
        />
      </v-col>
    </v-row>

    <v-row align="start">
      <p class="ma-0 mr-3">
        {{ mess["dialog_request_label_units_of_measurement"] }}
      </p>

      <v-radio-group
        v-model="copyOfForm.optime_unit"
        class="ma-0 pa-0"
        row
      >
        <v-radio
          v-for="item in units"
          :key="item"
          :label="item"
          :value="item"
          color="primary"
        />
      </v-radio-group>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.optime_plan"
          :label="
            `${mess['dialog_request_field_optime_plan']}, ${copyOfForm.unit ||
              ''}`
          "
          :error-messages="errors.collect('optime_plan')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_plan"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-3">
        <v-text-field
          v-model="copyOfForm.optime_actual"
          :label="
            `${mess['dialog_request_field_optime_actual']}, ${copyOfForm.unit || ''}`
          "
          :error-messages="errors.collect('optime_actual')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_actual"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.optime_average"
          :label="
            `${
              mess['dialog_request_field_optime_average_in_3']
            }, ${copyOfForm.unit || ''}`
          "
          :error-messages="errors.collect('optime_average')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_average"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.material"
          :label="mess['dialog_request_field_material']"
          :error-messages="errors.collect('material')"
          outlined
          dense
          data-vv-name="material"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.size_1"
          :label="mess['dialog_request_field_size_1']"
          :error-messages="errors.collect('size_1')"
          outlined
          dense
          data-vv-name="size_1"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.size_2"
          :label="mess['dialog_request_field_size_2']"
          :error-messages="errors.collect('size_2')"
          outlined
          dense
          data-vv-name="size_2"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.hole_size"
          :label="mess['dialog_request_field_hole_size']"
          :error-messages="errors.collect('hole_size')"
          outlined
          dense
          data-vv-name="hole_size"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.total_mill_loading"
          :label="mess['dialog_request_field_total_mill_loading']"
          :error-messages="errors.collect('total_mill_loading')"
          outlined
          dense
          data-vv-name="total_mill_loading"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.mill_rotation"
          :label="mess['dialog_request_field_mill_rotation_speed']"
          :error-messages="errors.collect('mill_rotation')"
          outlined
          dense
          data-vv-name="mill_rotation"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.size_grinding_media"
          :label="
            mess['dialog_request_field_size_and_composition_of_grinding_media']
          "
          :error-messages="errors.collect('size_grinding_media')"
          outlined
          dense
          data-vv-name="size_grinding_media"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pr-2">
        <v-text-field
          v-model="copyOfForm.material_grinding_media"
          :label="mess['dialog_request_field_material_of_grinding_media']"
          :error-messages="errors.collect('material_grinding_media')"
          outlined
          dense
          data-vv-name="material_grinding_media"
        />
      </v-col>

      <v-col cols="4" class="pa-0">
        <v-text-field
          v-model="copyOfForm.loading_volume"
          :label="mess['dialog_request_field_loading_volume_of_grinding_media']"
          :error-messages="errors.collect('loading_volume')"
          outlined
          dense
          data-vv-name="loading_volume"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import getArticles from "@/mixins/GetArticles";
import getEquipments from "@/mixins/GetEquipments";
import RequestForm from "@/mixins/RequestForm";

/**
 * @memberOf RequestDialog
 * @name GrindingForm
 * @desc Компонент для отрисовки формы "Измельчение"
 *
 * @vue-prop { Object } process - Текущий выбранный процесс.
 *
 * @vue-data { Object } copyOfForm - Сюда записываем данные из полей
 * @vue-data { requestDialogDatePicker } dateOfSale - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfIncident - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfRequest - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе Globals/Type Definitions
 * @vue-data { String | null } [searchAdditionalArticle=null] - Тут хранится введенный в строку поиска element-артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { String | null } [searchEquipment=null] - Тут хранится введенный в строку поиска оборудования текст.
 * @vue-data { String | null } [searchElementArticle=null] - Тут хранится введенный в строку поиска element-артикула текст.
 * @vue-data { String | null } [searchOriginalArticle=null] - Тут хранится введенный в строку поиска артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { Array } [searchedArticles=[]] - Тут хранится результат поиска по артикулам.
 * @vue-data { Array } [searchedAdditionalArticles=[]] - Тут хранится результат поиска по артикулам на основе текста из searchArticleAdditional.
 * @vue-data { Array } [searchedElementArticles=[]] - Тут хранится результат поиска по original-артикулам.
 *
 * @vue-computed { String } currentDate - Текущая дата
 * @vue-computed { Object[] } damages - Возвращает варианты для select-а "Повреждение сопряженных деталей".
 * @vue-computed { Object[] } requestForms - Возвращает массив элементов для select-a "Форма запроса".
 * @vue-computed { Object[] } requestReasons - Возвращает массив элементов для select-a "Причина обращения".
 * @vue-computed { Object[] } serviceEngineer - Возвращает массив элементов для select-a "Выезд сервисного инжеренра".
 * @vue-computed { String[] } units - Возвращает массив единиц измерения
 *
 * @vue-event initDefaultData - Метод для проставления текущей даты всем объектам используемым для отрисовки datePicker.
 * Это нужно для того чтобы datePicker не был пустым при открытии поп-апа.
 */
export default {
  name: "GrindingForm",
  inject: ["$validator"],
  mixins: [getArticles, getEquipments, RequestForm],
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copyOfForm: {},
      dateOfSale: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfSale.isOpen = false;
            this.dateOfSale.date = this.copyOfForm.dateOfSale;
          }
        },
        save: () => {
          this.copyOfForm.dateOfSale = this.dateOfSale.date;
          this.dateOfSale.close();
        }
      },
      dateOfIncident: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfIncident.isOpen = false;
            this.dateOfIncident.date = this.copyOfForm.dateOfIncident;
          }
        },
        save: () => {
          this.copyOfForm.dateOfIncident = this.dateOfIncident.date;
          this.dateOfIncident.close();
        }
      },
      dateOfRequest: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfRequest.isOpen = false;
            this.dateOfRequest.date = this.copyOfForm.dateOfRequest;
          }
        },
        save: () => {
          this.copyOfForm.dateOfRequest = this.dateOfRequest.date;
          this.dateOfRequest.close();
        }
      },
      searchAdditionalArticle: null,
      searchElementArticle: null,
      searchOriginalArticle: null,
      searchEquipment: null,
      searchedAdditionalArticles: [],
      searchedElementArticles: []
    };
  },
  computed: {
    currentDate() {
      return new Date().toISOString().substr(0, 10);
    },
    damages() {
      return this.process?.params?.damage || [];
    },
    errors() {
      return {};
    },
    requestForms() {
      return this.process?.params?.request_form || [];
    },
    requestReasons() {
      return this.process?.params?.request_reason || [];
    },
    serviceEngineer() {
      return this.process?.params?.service_engineer || [];
    },
    units() {
      const {
        dialog_request_button_units_ton: ton,
        dialog_request_button_units_hours: hours,
        dialog_request_button_units_days: days
      } = this.mess;

      return [ton, hours, days];
    }
  },
  mounted() {
    this.initDefaultData();
  },
  methods: {
    initDefaultData() {
      this.copyOfForm.dateOfSale = this.currentDate;
      this.copyOfForm.dateOfIncident = this.currentDate;
      this.copyOfForm.dateOfRequest = this.currentDate;
    }
  }
};
</script>
